export type AckMessageType = `${string}_ACK`

export interface HostBridgeMessage {
  type: HostMessageType | AckMessageType
  id?: string
  correlationId?: string
  payload?: object
}

export interface HelpCenterBridgeMessage {
  type: HelpCenterMessageType
  id: string
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export type HandlerFunction = Function

export enum HostMessageType {
  'HOST_IS_READY' = 'HOST_IS_READY',
  'HOST_ASKS_FOR_SHUTDOWN' = 'HOST_ASKS_FOR_SHUTDOWN',
  'HOST_APP_PROVIDES_CHAT_CONFIG' = 'HOST_APP_PROVIDES_CHAT_CONFIG',
  'HOST_ALLOWED_FILE_DOWNLOAD' = 'HOST_ALLOWED_FILE_DOWNLOAD',
  'HOST_FILE_DOWNLOAD_SUCCESS' = 'HOST_FILE_DOWNLOAD_SUCCESS',
}

export enum HelpCenterMessageType {
  'HELPCENTER_INIT_STARTED' = 'HELPCENTER_INIT_STARTED',
  'HELPCENTER_INIT_IS_DONE' = 'HELPCENTER_INIT_IS_DONE',
  'HELPCENTER_SHUTDOWN_READY' = 'HELPCENTER_SHUTDOWN_READY',
  'HELPCENTER_ASKS_FOR_SHUTDOWN' = 'HELPCENTER_ASKS_FOR_SHUTDOWN',
  'HELPCENTER_ASKS_FOR_FILE_DOWNLOAD' = 'HELPCENTER_ASKS_FOR_FILE_DOWNLOAD',
  'CLIENT_ASKS_FOR_CHAT_CONFIG' = 'CLIENT_ASKS_FOR_CHAT_CONFIG',
  'CLIENT_CHAT_STARTED' = 'CLIENT_CHAT_STARTED',
  'HELPCENTER_ENCOUNTERED_ERROR' = 'HELPCENTER_ENCOUNTERED_ERROR',
}

export interface HostIsReadyMessage extends HostBridgeMessage {
  type: HostMessageType.HOST_IS_READY
  payload: {
    isHelpcenterFullScreen: boolean
    supportedMessageTypes: HelpCenterMessageType[]
  }
}

export interface HostProvidesChatConfigMessage extends HostBridgeMessage {
  type: HostMessageType.HOST_APP_PROVIDES_CHAT_CONFIG
  payload: {
    delivery?: {
      orderId: string
      customerNote: string
      entityNote: string
      address: string
      totalAmountInCurrency: string
      phoneNumber: string
      name: string
    }
    translation?: {
      userPreferredLanguage: string
      supportedLanguages: string[]
    }
    phoneCallingType?: 'masked' | 'normal' | 'none'
    quickReplies?: string[]
  }
}

export interface FileDownloadMessage {
  id: string
  payload: {
    url: string
  }
}
